import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-team.svg'
import _imports_2 from '@/assets/icon/icon-activity.svg'
import _imports_3 from '@/assets/icon/icon-activity-list.svg'
import _imports_4 from '@/assets/icon/icon-check-data-b.svg'
import _imports_5 from '@/assets/icon/icon-reward.svg'
import _imports_6 from '@/assets/icon/icon-roadmap.svg'
import _imports_7 from '@/assets/icon/icon-people.svg'
import _imports_8 from '@/assets/icon/icon-edit-profile.svg'
import _imports_9 from '@/assets/icon/icon-back-to.svg'
import _imports_10 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_11 from '@/assets/images/landing/creator-challenge-logo.svg'
import _imports_12 from '@/assets/images/landing/curve-w.svg'
import _imports_13 from '@/assets/oval.svg'
import _imports_14 from '@/assets/icon/icon-leader-w.svg'
import _imports_15 from '@/assets/icon/icon-close-modal.svg'
import _imports_16 from '@/assets/images/landing/bg-mountain.svg'
import _imports_17 from '@/assets/images/landing/bg-mountain-m.svg'
import _imports_18 from '@/assets/images/landing/bg-tree-l.svg'
import _imports_19 from '@/assets/images/landing/bg-tree-r.svg'
import _imports_20 from '@/assets/images/landing/bonus-flag.svg'
import _imports_21 from '@/assets/images/register/fit-firm-fun.png'
import _imports_22 from '@/assets/images/register/Fit-firm-fun-qr.png'
import _imports_23 from '@/assets/images/register/point.svg'
import _imports_24 from '@/assets/images/register/creater.png'
import _imports_25 from '@/assets/images/register/creator-community.png'
import _imports_26 from '@/assets/icon/icon-error.svg'
import _imports_27 from '@/assets/icon/icon-save.svg'
import _imports_28 from '@/assets/images/landing/learn.svg'
import _imports_29 from '@/assets/images/landing/coin-star.svg'
import _imports_30 from '@/assets/images/landing/post.svg'
import _imports_31 from '@/assets/images/landing/sponsoring.svg'
import _imports_32 from '@/assets/icon/icon-circle-star.svg'
import _imports_33 from '@/assets/icon/icon-check-data-b-light.svg'
import _imports_34 from '@/assets/icon/icon-cut-ribbon.svg'
import _imports_35 from '@/assets/icon/icon-start.svg'
import _imports_36 from '@/assets/icon/icon-trophy.svg'
import _imports_37 from '@/assets/icon/icon-calendar.svg'
import _imports_38 from '@/assets/images/landing/opening-img.svg'
import _imports_39 from '@/assets/images/landing/opening-img-i.svg'
import _imports_40 from '@/assets/images/landing/opening-img-m.svg'
import _imports_41 from '@/assets/images/landing/register-img-01.svg'
import _imports_42 from '@/assets/images/landing/register-img-m-01.svg'
import _imports_43 from '@/assets/images/landing/green-ribbon.svg'
import _imports_44 from '@/assets/images/landing/weekly-reward.svg'
import _imports_45 from '@/assets/images/landing/weekly-reward-m.svg'
import _imports_46 from '@/assets/images/landing/reward-1-10.svg'
import _imports_47 from '@/assets/images/landing/reward-11-70.svg'
import _imports_48 from '@/assets/icon/amway-logo.svg'
import _imports_49 from '@/assets/icon/icon-phone.svg'
import _imports_50 from '@/assets/icon/icon-close.svg'
import _imports_51 from '@/assets/icon/icon-back.svg'
import _imports_52 from '@/assets/icon/icon-trash.svg'


const _hoisted_1 = { class: "challenge" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-area desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<a href=\"#team\"><img src=\"" + _imports_1 + "\">ทีมของคุณ </a><a href=\"#activity\"><img src=\"" + _imports_2 + "\">กิจกรรม </a><a href=\"#activity-lists\"><img src=\"" + _imports_3 + "\">ตารางกิจกรรม </a><a href=\"#register\"><img src=\"" + _imports_4 + "\">วิธีการเข้าร่วม </a><a href=\"#reward\"><img src=\"" + _imports_5 + "\">ของรางวัล </a>", 5)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }),
  /*#__PURE__*/_createTextVNode("กิจกรรมรายสัปดาห์ ")
], -1)
const _hoisted_13 = { class: "profile-area" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_16 = { class: "profile-info-area" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_18 = { class: "profile-info-name" }
const _hoisted_19 = { class: "profile-info-id" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_23 = { class: "header-area mobile" }
const _hoisted_24 = { class: "header-logo-area" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_26 = {
  class: "profile-area",
  id: "profile-area-m"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  class: "profile-info",
  id: "profile-info-m"
}
const _hoisted_29 = { class: "profile-info-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_31 = { class: "profile-info-name" }
const _hoisted_32 = { class: "profile-info-id" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_36 = {
  class: "sub-menu",
  id: "sub-menu"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("ทีมของคุณ ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("กิจกรรม ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("ตารางกิจกรรม ")
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("วิธีการเข้าร่วม ")
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode("ของรางวัล ")
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }),
  /*#__PURE__*/_createTextVNode("กิจกรรมรายสัปดาห์ ")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("section", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-content" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_11,
        alt: "Amway Creator Challenge"
      })
    ])
  ])
], -1)
const _hoisted_54 = { class: "first-section" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  id: "team",
  style: {"display":"block","position":"relative","top":"-250px","visibility":"hidden"}
}, null, -1)
const _hoisted_56 = { class: "control-red-ribbon" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h5", null, "ทีมของคุณ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  class: "curve"
}, null, -1)
const _hoisted_60 = {
  class: "container",
  style: {"text-align":"center","margin-top":"80px"}
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  height: "35",
  src: _imports_13,
  alt: ""
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "container" }
const _hoisted_64 = { class: "lists-member-card" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "member-thumbnail-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_14 })
], -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "หัวหน้าทีม", -1)
const _hoisted_68 = { style: {"white-space":"pre-line"} }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", { class: "position" }, "สมาชิก", -1)
const _hoisted_72 = { style: {"white-space":"pre-line"} }
const _hoisted_73 = { class: "bonus-point-container" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "bg-mountain"
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  class: "bg-mountain-m"
}, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "bg-tree-l"
}, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  class: "bg-tree-r"
}, null, -1)
const _hoisted_78 = { class: "container" }
const _hoisted_79 = { class: "bonus-point-content" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_20 + "\" class=\"bonus-flag\"><h5>พิเศษ รับครีเอเตอร์พอยท์เพิ่ม</h5><h5> เพียงท่านเข้าร่วม <span style=\"color:#39a767;\">Facebook Close Group</span></h5><p> (คะแนนส่วนนี้จะไม่ถูกรวมเป็นคะแนนรายสัปดาห์ แต่จะถูกรวมในการคิดคะแนนรอบชิงชนะเลิศเท่านั้น) </p><div class=\"success-detail\"><div class=\"success-detail-list\"><div class=\"form-title-section mt-16\"><span>1.</span><h4 class=\"title\">รวมพลคน Fit Firm Fun</h4></div><div class=\"success-detail-imgs\"><img src=\"" + _imports_21 + "\" class=\"img-fitfirmfun\"><img src=\"" + _imports_22 + "\" class=\"img-qrcode\"><img src=\"" + _imports_23 + "\" class=\"img-point\"></div></div><div class=\"success-detail-list\"><div class=\"form-title-section mt-16\"><span>2.</span><h4 class=\"title\">Creators Thailand Community</h4></div><div class=\"success-detail-imgs\"><img src=\"" + _imports_24 + "\" class=\"img-creater\"><img src=\"" + _imports_25 + "\" class=\"img-qrcode\"><img src=\"" + _imports_23 + "\" class=\"img-point\"></div></div></div>", 5)
const _hoisted_85 = { class: "success-facebook-link mt-16" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", null, "บัญชี Facebook Profile ส่วนตัวของคุณ", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-error-text alert-error",
  id: "name-alert"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_26,
    class: "icon-error"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "กรอกข้อมูลไม่ถูกต้อง")
], -1)
const _hoisted_88 = { class: "success-facebook-link example-detail" }
const _hoisted_89 = { class: "information-text fb-page" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("p", null, "บัญชี Facebook Profile ส่วนตัวของคุณ ที่ไม่ใช่ Facebook Page", -1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" วิดีโอตัวอย่างการคัดลอกลิงก์ Facebook Profile : ")
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_27,
    width: "34px",
    height: "34px",
    style: {"margin-right":"8px"}
  }),
  /*#__PURE__*/_createTextVNode("บันทึกข้อมูล ")
], -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" id=\"activity\"><div class=\"section-title\" style=\"margin-top:-85px;padding-top:96px;\"><span>ครีเอเตอร์ ชาเลนจ์ 2022</span></div><div class=\"row mt-16 mx-0\"><div class=\"activity-content\"><img src=\"" + _imports_28 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> พัฒนาทักษะการขายระดับเริ่มต้นสู่ระดับมือโปร <br>โดยมีเนื้อหาการเป็น <b>ครีเอเตอร์,การขาย และการสปอนเซอร์</b><br>ผ่านการเรียนออนไลน์ทุกสัปดาห์ </div><div class=\"ad-point mobile\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> หากท่านเรียนจบ 1 บทเรียน <br><span>จะได้รับ 2 คะแนน ต่อบทเรียน</span></div></div></div></div><div class=\"activity-content\"><img src=\"" + _imports_30 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> โพสต์คอนเทนต์บนโซเชียลมีเดียของนักธุรกิจแอมเวย์ <br>กำหนดให้โพสต์บน <b>เฟซบุ๊ก เพจ หรือ อินสตาแกรม ครีเอเตอร์</b><br>โดยทำคอนเทนต์จากผลิตภัณฑ์นิวทริไลท์ 3 โพสต์ ต่อสัปดาห์ <br>พร้อมติดแฮชแท็กบังคับ <b>#A7070challenge #Nutrilite</b><br>และอีก 1 แฮชแท็ก จะแจ้งให้ทราบในแต่ละสัปดาห์ </div><div class=\"ad-point mobile\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> หากท่านโพสต์ครบ 3 โพสต์ <br><span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div><div class=\"activity-content\"><img src=\"" + _imports_31 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> ขยายเครือข่ายครอบครัวแอมเวย์โดยการ <br><b>สปอนเซอร์นักธุรกิจแอมเวย์</b> หรือ <b>สปอนเซอร์สมาชิก</b><br>พร้อมกับ <b>สร้างยอดสั่งซื้อผลิตภัณฑ์ในกลุ่มนิวทริไลท์</b></div><div class=\"ad-point mobile\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> สปอนเซอร์นักธุรกิจแอมเวย์ <span>จะได้รับคะแนน 5 คะแนน</span><br>สปอนเซอร์สมาชิกแอมเวย์ <span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div></div><div class=\"row mx-0 desktop\"><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> หากท่านเรียนจบ 1 บทเรียน <br><span>จะได้รับ 2 คะแนน ต่อบทเรียน</span></div></div></div><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> หากท่านโพสต์ครบ 3 โพสต์ <br><span>จะได้รับคะแนน 3 คะแนน</span></div></div></div><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_29 + "\"><div class=\"ad-point-text\"> สปอนเซอร์นักธุรกิจแอมเวย์ <span>จะได้รับคะแนน 5 คะแนน</span><br>สปอนเซอร์สมาชิกแอมเวย์ <span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div><div class=\"button-section\" style=\"padding:0 24px;\"><a target=\"_blank\" href=\"/brochure_creators_challenge.pdf\"><button type=\"button\" class=\"btn-red\"><div><img src=\"" + _imports_32 + "\" width=\"34px\" height=\"34px\" style=\"margin-right:12px;\"> รายละเอียดการได้รับคะแนน </div></button></a></div></div>", 1)
const _hoisted_95 = /*#__PURE__*/_createStaticVNode("<section id=\"activity-lists\" style=\"margin-top:-84px;padding-top:84px;\"><div class=\"activity-lists-section\"><div class=\"container\"><div class=\"section-title\">ตารางกิจกรรม</div><div class=\"row mx-0 desktop\" style=\"justify-content:center;margin-top:65px;\"><div class=\"activity-lists\"><img src=\"" + _imports_33 + "\"><div class=\"activity-lists-date\">12-20 ก.พ.</div><div class=\"activity-lists-text\">สมัครเข้าร่วมกิจกรรม</div></div><div class=\"activity-lists\"><img src=\"" + _imports_34 + "\"><div class=\"activity-lists-date\">26 ก.พ.</div><div class=\"activity-lists-text\">กิจกรรมเปิดตัวการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_35 + "\"><div class=\"activity-lists-date\">5 มี.ค.</div><div class=\"activity-lists-text\">เริ่มการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_2 + "\"><div class=\"activity-lists-date\">13 พ.ค.</div><div class=\"activity-lists-text\">จบการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_36 + "\"><div class=\"activity-lists-date\">28 พ.ค.</div><div class=\"activity-lists-text\">ประกาศผลผู้ชนะเลิศ</div></div></div><div class=\"row mx-0 mobile\" style=\"justify-content:flex-start;margin-top:65px;\"><div class=\"activity-lists\"><img src=\"" + _imports_33 + "\"><div class=\"activity-lists-date\">12-20 ก.พ.</div><div class=\"activity-lists-text\">สมัครเข้าร่วมกิจกรรม</div></div><div class=\"activity-lists\"><img src=\"" + _imports_34 + "\"><div class=\"activity-lists-date\">26 ก.พ.</div><div class=\"activity-lists-text\"> กิจกรรมเปิดตัว <br>การแข่งขัน </div></div><div class=\"activity-lists\"><img src=\"" + _imports_2 + "\"><div class=\"activity-lists-date\">13 พ.ค.</div><div class=\"activity-lists-text\">จบการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_35 + "\"><div class=\"activity-lists-date\">5 มี.ค.</div><div class=\"activity-lists-text\">เริ่มการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_36 + "\"><div class=\"activity-lists-date\">28 พ.ค.</div><div class=\"activity-lists-text\"> ประกาศผล <br>ผู้ชนะเลิศ </div></div></div><div class=\"button-section\" style=\"margin-top:40px;padding:0 24px;\"><a target=\"_blank\" href=\"/brochure_creators_challenge.pdf\"><button type=\"button\" class=\"btn-red\"><div><img src=\"" + _imports_37 + "\" width=\"34px\" height=\"34px\" style=\"margin-right:12px;\"> ตารางแข่งขันและประกาศผล </div></button></a></div></div></div><div class=\"opening-section\"><div class=\"container\"><div style=\"position:relative;\"><div class=\"section-title\">พบกับกิจกรรม</div><div style=\"font-size:32px;font-weight:700;line-height:32px;text-align:center;color:#39a767;\">เปิดตัวการแข่งขัน</div><img src=\"" + _imports_38 + "\" class=\"opening-image\"><img src=\"" + _imports_39 + "\" class=\"opening-image-i\"><img src=\"" + _imports_40 + "\" class=\"opening-image-m\"></div></div></div></section>", 1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("section", {
  id: "register",
  style: {"margin-top":"-84px","padding-top":"84px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "register-section" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "วิธีสมัครเข้าร่วมการแข่งขัน"),
      /*#__PURE__*/_createElementVNode("div", { class: "register-img" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_41,
          height: "324px"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "register-img-m" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_42,
          width: "100%"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "register-text" }, [
        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"668px"} }, [
          /*#__PURE__*/_createElementVNode("b", null, "หัวหน้าทีม"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* ดํารงคุณสมบัติเป็นนักธุรกิจแอมเวย์ระดับบรอนซ์ที่ได้รับรางวัล บรอนซ์บิวเดอร์อย่างน้อย 1 ครั้ง นับตั้งแต่เดือนกันยายน 2563 ถึง มกราคม 2565 หรือดำรงคุณสมบัติ/เคยดำรงคุณสมบัติเป็นนักธุรกิจแอมเวย์ระดับเข็มเงินและสูงขึ้นไป ภายในเดือน มกราคม 2565 "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("b", null, "สมาชิกทีม"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* นักธุรกิจแอมเวย์ "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* สมาชิกในกลุ่มทุกท่านจะต้องมีบัญชี "),
          /*#__PURE__*/_createElementVNode("b", null, "เฟซบุ๊ก เพจ หรือ อินสตาแกรม ครีเอเตอร์"),
          /*#__PURE__*/_createTextVNode(" เพื่อใช้ในการทำกิจกรรม โดยเลือกได้ 1 แพลตฟอร์มเท่านั้น และไม่อนุญาตให้เปลี่ยนแพลตฟอร์มระหว่างการแข่งขัน "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* "),
          /*#__PURE__*/_createElementVNode("b", null, "นักธุรกิจแอมเวย์รหัสคู่มีสิทธิเข้าร่วมแข่งขันได้ทั้ง 2 ท่าน"),
          /*#__PURE__*/_createTextVNode(" โดยต้องสมัครอยู่ทีมเดียวกันเท่านั้น เนื่องจากการนับคะแนน จากการสปอนเซอร์จะนับต่อรหัสเท่านั้น "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* ผู้เข้าแข่งขัน 1 ท่านมีสิทธิ์เข้าร่วมได้เพียง 1 ทีมเท่านั้น "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* หากมีสมาชิกในทีมลาออกจากการแข่งขัน ลาออกจากธุรกิจแอมเวย์ หรือสิ้นสุดสถานภาพนักธุรกิจแอมเวย์ สงวนสิทธิไม่รับสมาชิกใหม่เข้ามาทดแทน ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "video-size" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "video-box" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "100%",
            height: "100%",
            src: "https://www.youtube.com/embed/0QkR15ypWhs",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_97 = /*#__PURE__*/_createStaticVNode("<section id=\"reward\" style=\"margin-top:-180px;padding-top:180px;\"><div class=\"reward-section\"><div style=\"max-width:1276px;margin:0 auto;\"><div class=\"ribbon\"><img src=\"" + _imports_43 + "\"><div class=\"ribbon-text\">แจกรางวัลทุกสัปดาห์</div></div><div class=\"weekly-reward\"><div class=\"weekly-reward-text\"> ของรางวัลรายสัปดาห์ <br><span>มูลค่ารวม 3,000,000 บาท</span></div><img src=\"" + _imports_44 + "\" width=\"100%\" height=\"auto\"></div><div class=\"weekly-reward-m\"><div class=\"weekly-reward-text\"> ของรางวัลรายสัปดาห์ <br><span>มูลค่ารวม 3,000,000 บาท</span></div><img src=\"" + _imports_45 + "\" width=\"100%\" height=\"auto\"></div></div><div class=\"winner-reward\"><div class=\"container\"><div class=\"winner-reward-title\"><div class=\"wrt-b\">รางวัลชนะเลิศและรางวัลชมเชย</div><div class=\"wrt-text\"> 70 ทีม ที่ได้คะแนนรวมสะสมตลอดทั้งโปรแกรม การแข่งขัน 70 วันจะได้รับรางวัลดังต่อไปนี้ </div><div class=\"wrt-green\">รวมมูลค่าของรางวัลชนะเลิศมูลค่า 4,000,000 บาท</div></div><div class=\"winner-reward-box\"><img src=\"" + _imports_46 + "\"><div class=\"wr-detail\"><div class=\"wr-title\">รางวัลชนะเลิศ 10 ทีม</div><div class=\"wr-sub-title\">(สำหรับทีมที่ได้คะแนนรวมสะสมสูงสุดลำดับ 1-10)</div><div class=\"wr-text\"> รับแพ็คเกจไปท่องเที่ยวทริปญี่ปุ่น เกียวโต โอซาก้า <br>พร้อมกับกูรูด้านการถ่ายภาพ สร้างคอนเทนต์แบบครีเอเตอร์โปร <div>มูลค่า 350,000 บาท/ทีม</div></div></div></div><div class=\"winner-reward-box\"><img src=\"" + _imports_47 + "\"><div class=\"wr-detail\"><div class=\"wr-title\">รางวัลชมเชย 60 ทีม</div><div class=\"wr-sub-title\">(สำหรับทีมที่ได้คะแนนรวมสะสมสูงสุดลำดับ 11-70)</div><div class=\"wr-text\"> รับกิ๊ฟท์เซตกล้องโพลารอยด์ครีเอเตอร์สุดเก๋ <div>ท่านละ 1 ชุด มูลค่า 1,600 บาท</div></div></div></div><div style=\"margin-top:48px;padding:0 16px;font-size:16px;font-weight:700;line-height:24px;text-align:center;\"> ผู้เข้าแข่งขันที่ได้รับรางวัล ซึ่งมีมูลค่ามากกว่า 1,000 บาท <br class=\"mobile\">มีหน้าที่ชำระภาษีหัก ณ ที่จ่าย 5% ของมูลค่าของรางวัล <br>ตามคำสั่งของกรมสรรพากรที่ ท.ป.101/2544 <br class=\"mobile\">โดยต้องชำระเป็นเงินสดเท่านั้น </div></div></div></div></section><section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_48 + "\" height=\"40px\"></div><div class=\"footer-address\"> บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240 </div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_49 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 2)
const _hoisted_99 = {
  class: "popup",
  id: "choose-account"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "popup-bg" }, null, -1)
const _hoisted_101 = { class: "popup-content-area" }
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<div class=\"popup-title\"> กรุณาเลือกบัญชีของคุณ <br>ที่ต้องการเข้าร่วมกิจกรรม </div><div class=\"popup-content-choice\"><div class=\"custom-radio\"><input type=\"radio\" name=\"person\" id=\"person-1\" checked><label for=\"person-1\"><div class=\"label-check-radio\"></div><div class=\"label-detail\"><div class=\"label-name\">คุณชัญญ์ชนพร นาทพัฒนพงศ์</div><div class=\"label-id\">รหัสนักธุรกิจแอมเวย์ 1234811</div></div></label></div><div class=\"custom-radio\"><input type=\"radio\" name=\"person\" id=\"person-2\"><label for=\"person-2\"><div class=\"label-check-radio\"></div><div class=\"label-detail\"><div class=\"label-name\">คุณกรกช นาทพัฒนพงศ์</div><div class=\"label-id\">รหัสนักธุรกิจแอมเวย์ 1234812</div></div></label></div></div>", 2)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", null, "ยืนยัน", -1)
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = {
  class: "popup popup-slide",
  id: "condition-policy"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "popup-bg" }, null, -1)
const _hoisted_108 = { class: "popup-content-area p-0 pt-24" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "popup-bar hidden-desktop" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "btn-close-popup",
    src: _imports_51
  }),
  /*#__PURE__*/_createTextVNode("เงื่อนไขและข้อกําหนด ")
], -1)
const _hoisted_110 = /*#__PURE__*/_createStaticVNode("<div class=\"popup-title\">คำรับรองของผู้สมัคร</div><div class=\"popup-content\"><ol><li> ข้าพเจ้าตกลงสมัครเข้าร่วมกิจกรรม ครีเอเตอร์ ชาเลนท์ 2022 &quot;70 วัน เปลี่ยนความชอบเป็นรายได้ด้วยธุรกิจแอมเวย์ มุ่งสู่เป้าหมายแอมเวย์ 70 ปี” และยอมรับพร้อมทั้งปฎิบัติตามกติกาที่บริษัทกำหนดทุกประการ </li><li> ข้าพเจ้าขอรับรองว่า รายละเอียดส่วนบุคคลที่ได้ให้ไว้แก่บริษัทนี้เป็นจริงและถูกต้องทุกประการ ทั้งยินยอมให้บริษัทนำรายละเอียด ข้อมูล ภาพถ่าย ตำแหน่ง อาชีพ รวมถึงข้อมูลที่เกี่ยวกับประสบการณ์ที่ใช้หรือร่วมกิจกรรมตามโปรแกรมนี้ไปใช้เพื่อการประชาสัมพันธ์ใดๆ ในกิจกรรมของบริษัท และหรือการโปรโมทผลิตภัณฑ์แอมเวย์ทุกรูปแบบไม่ว่าจะเป็นเอกสารวิดีโอ เว็บไซต์โซเชียลมีเดีย ภาพ-เสียง ของกลุ่มบริษัทแอมเวย์โดยข้าพเจ้ายินยอมให้สิทธิ์ดังกล่าวข้างต้นทั้งการใช้เผยแพร่ทำซ้ำได้ทั่วโลก โดยไม่มีค่าตอบแทนและไม่มีกำหนดเวลา ทั้งข้าพเจ้าขอสละสิทธิ์ในการเรียกร้องค่าเสียหายใดๆ อันเนื่องจากการดำเนินหรือเข้าร่วมกิจกรรมในครั้งนี้ </li><li> ผู้ที่ได้รับรางวัล จะต้องเป็นผู้ที่ปฏิบัติถูกต้องตามเงื่อนไขจรรยาบรรณ และระเบียบปฏิบัติของบริษัทแอมเวย์ (ประเทศไทย) จำกัด เท่านั้น </li><li> คะแนนครีเอเตอร์พอยท์ที่เกิดจากการสปอนเซอร์นักธุรกิจหรือสมาชิกแอมเวย์รายใหม่ที่มียอดซื้อผลิตภัณฑ์นิวทริไลท์ตามที่กำหนด หากมีการคืนผลิตภัณฑ์ดังกล่าว บริษัทฯ ขอสงวนสิทธิ์ในการเรียกคืนผลประโยชน์ที่ผู้แข่งขันได้รับไปแล้ว </li><li> คำตัดสินของคณะกรรมการถือเป็นที่สิ้นสุด และ บริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขและของรางวัลโดยไม่ต้องแจ้งให้ทราบล่วงหน้า </li></ol></div><div class=\"popup-footer\"><div class=\"popup-footer-text\"> ข้าพเจ้ารับว่าใบสมัครนี้เป็นส่วนหนึ่งของข้อตกลง ซึ่งไม่เพียงแต่จะครอบคลุมถึงเรื่องในปัจจุบันเท่านั้น หากแต่ยังคงครอบคลุมถึงการรับรองในอนาคตด้วย </div><div class=\"custom-checkbox\"><input type=\"checkbox\" name=\"accept-policy\" id=\"accept-policy\"><label for=\"accept-policy\">ฉันอ่านและยอมรับเงื่อนไข</label></div><button type=\"button\" class=\"btn-red btn-i-next\" id=\"btn-accept-cookies\" style=\"width:calc(100% - 16px);margin:0 8px;\"><div>กดเพื่อไปต่อ</div></button></div>", 3)
const _hoisted_113 = {
  class: "main-popup-dim d-none",
  id: "delete-team"
}
const _hoisted_114 = { class: "main-popup-content" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = /*#__PURE__*/_createStaticVNode("<h4>คุณแน่ใจหรือไม่ที่จะลบทีมของคุณ</h4><p> หากคุณลบทีม สมาชิกทั้งหมดจะถูกออกจากการแข่งขัน <br>และต้องทำการลงทะเบียนเพื่อเข้าร่วมกิจกรรมใหม่ทั้งหมด </p><h5 class=\"title-team\">ทีมของคุณ</h5><h4>FITFIRMFUN</h4><div class=\"profile-thumbnail\"><div class=\"profile-thumbnail-img\" style=\"background-image:url(&#39;assets/images/people-01.png&#39;);\"></div></div><p class=\"position\">สมาชิกทีม</p><p class=\"name\"> กชกร <br>อนันตวุฒิ </p><div class=\"button-group\"><button class=\"btn-solid btn-cancel\"><img src=\"" + _imports_15 + "\"> ยกเลิก </button><button class=\"btn-solid btn-confirm\"><img src=\"" + _imports_52 + "\"> ยืนยัน </button></div>", 8)
const _hoisted_125 = {
  class: "main-popup-dim d-none",
  id: "delete-member"
}
const _hoisted_126 = { class: "main-popup-content" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/_createStaticVNode("<h4> คุณแน่ใจหรือไม่ <br>ที่จะลบสมาชิกออกจากทีม </h4><p> หากคุณลบสมาชิกท่านนี้ออกจากทีม <br>สมาชิกท่านดังกล่าวต้องทำการสมัครเข้าร่วมกิจกรรมใหม่ทั้งหมด </p><div class=\"profile-thumbnail\"><div class=\"profile-thumbnail-img\" style=\"background-image:url(&#39;assets/images/people-01.png&#39;);\"></div></div><p class=\"position\">สมาชิกทีม</p><p class=\"name\"> กชกร <br>อนันตวุฒิ </p><div class=\"button-group\"><button class=\"btn-solid btn-cancel\"><img src=\"" + _imports_15 + "\"> ยกเลิก </button><button class=\"btn-solid btn-confirm\"><img src=\"" + _imports_52 + "\"> ยืนยัน </button></div>", 6)
const _hoisted_135 = {
  class: "example-dim d-none",
  id: "example-fb-profile"
}
const _hoisted_136 = { class: "example-content" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("img", { src: _imports_15 }, null, -1)
const _hoisted_138 = [
  _hoisted_137
]
const _hoisted_139 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" วิดีโอตัวอย่างการคัดลอกลิงก์ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Facebook Profile ")
], -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "example-content-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "420",
    height: "345",
    src: "https://www.youtube.com/embed/hg95UIFwz3E",
    frameborder: "0"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.dayjs().isSameOrAfter('2022-03-05') ? '/activity' : '/challenge',
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.dayjs().isSameOrAfter('2022-03-05'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/activity",
                  class: "btn-red",
                  style: {"width":"184px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showProfileInfo()))
            }, [
              _createElementVNode("img", {
                src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_19, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
                ])
              ]),
              _createVNode(_component_router_link, {
                to: "/profile",
                class: "link-black"
              }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _hoisted_21
                ]),
                _: 1
              }),
              _hoisted_22
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            class: "ham",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu(this)))
          }),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showProfileInfo()))
          }, [
            _createElementVNode("img", {
              src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
            }, null, 8, _hoisted_27)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_32, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            _createVNode(_component_router_link, {
              to: "/profile",
              class: "link-black"
            }, {
              default: _withCtx(() => [
                _hoisted_33,
                _hoisted_34
              ]),
              _: 1
            }),
            _hoisted_35
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu())),
            href: "#team"
          }, _hoisted_39),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openMenu())),
            href: "#activity"
          }, _hoisted_42),
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openMenu())),
            href: "#activity-lists"
          }, _hoisted_45),
          _createElementVNode("a", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openMenu())),
            href: "#register"
          }, _hoisted_48),
          _createElementVNode("a", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openMenu())),
            href: "#reward"
          }, _hoisted_51),
          (_ctx.dayjs().isSameOrAfter('2022-03-05'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/activity",
                class: "btn-red fixed",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openMenu())),
                style: {"right":"16px","bottom":"0","width":"calc(100% - 32px)"}
              }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_53,
    _createElementVNode("section", _hoisted_54, [
      _hoisted_55,
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("h4", null, _toDisplayString(_ctx.partyInfo ? _ctx.partyInfo.team.name : ""), 1)
      ]),
      _hoisted_58,
      _hoisted_59,
      _withDirectives(_createElementVNode("div", _hoisted_60, _hoisted_62, 512), [
        [_vShow, !_ctx.isLoaded]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", {
            class: _normalizeClass(`member-card ${ _ctx.$store.state.userInfo.party_id == _ctx.partyInfo.team.leader.party_id ? 'is-self' : ''}`)
          }, [
            _createElementVNode("div", {
              class: "member-thumbnail",
              style: _normalizeStyle({ backgroundImage: `url(${ _ctx.partyInfo.team.leader.image ? _ctx.partyInfo.team.leader.image : require('@/assets/images/landing/people.svg') })` })
            }, _hoisted_66, 4),
            _hoisted_67,
            _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.partyInfo ? _ctx.partyInfo.team.leader.name : ""), 1)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partyInfo.team.members, (member) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`member-card ${ _ctx.$store.state.userInfo.party_id == member.party_id ? 'is-self' : ''}`),
              key: member.id
            }, [
              _createElementVNode("div", {
                class: "member-thumbnail",
                style: _normalizeStyle({ backgroundImage: `url(${ member.image ? member.image : require('@/assets/images/landing/people.svg') })` })
              }, [
                _createElementVNode("div", {
                  class: "member-thumbnail-del d-none",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleModal('delete-member')))
                }, _hoisted_70)
              ], 4),
              _hoisted_71,
              _createElementVNode("p", _hoisted_72, _toDisplayString(member.name), 1)
            ], 2))
          }), 128))
        ])
      ], 512), [
        [_vShow, _ctx.isLoaded]
      ]),
      _createElementVNode("div", _hoisted_73, [
        _hoisted_74,
        _hoisted_75,
        _hoisted_76,
        _hoisted_77,
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _withDirectives(_createElementVNode("input", {
                class: "form-profile",
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.socialURL) = $event)),
                name: "search-team",
                placeholder: "URL Link",
                disabled: ""
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.socialURL,
                  void 0,
                  { trim: true }
                ]
              ]),
              _hoisted_87
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("p", null, [
                  _hoisted_91,
                  _createElementVNode("span", {
                    class: "text-success",
                    style: {"cursor":"pointer"},
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleModal('example-fb-profile')))
                  }, "คลิกที่นี่")
                ])
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-red no-fix mt-16",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submit($event)))
            }, _hoisted_93)
          ])
        ])
      ]),
      _hoisted_94
    ]),
    _hoisted_95,
    _hoisted_96,
    _hoisted_97,
    _createElementVNode("div", _hoisted_99, [
      _hoisted_100,
      _createElementVNode("div", _hoisted_101, [
        _createElementVNode("img", {
          class: "btn-close-popup",
          src: _imports_50,
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closePopup('choose-account')))
        }),
        _hoisted_102,
        _createElementVNode("button", {
          type: "button",
          class: "w-100 btn-red btn-i-confirm",
          onClick: _cache[14] || (_cache[14] = ($event: any) => {
            _ctx.checkCookies();
            _ctx.closePopup('choose-account');
          })
        }, _hoisted_105)
      ])
    ]),
    _createElementVNode("div", _hoisted_106, [
      _hoisted_107,
      _createElementVNode("div", _hoisted_108, [
        _hoisted_109,
        _createElementVNode("img", {
          class: "btn-close-popup hidden-mobile",
          src: _imports_50,
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closePopup('condition-policy')))
        }),
        _hoisted_110
      ])
    ]),
    _createElementVNode("div", _hoisted_113, [
      _createElementVNode("div", _hoisted_114, [
        _createElementVNode("button", {
          class: "btn-close-popip",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleModal('delete-team')))
        }, _hoisted_116),
        _hoisted_117
      ])
    ]),
    _createElementVNode("div", _hoisted_125, [
      _createElementVNode("div", _hoisted_126, [
        _createElementVNode("button", {
          class: "btn-close-popip",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleModal('delete-member')))
        }, _hoisted_128),
        _hoisted_129
      ])
    ]),
    _createElementVNode("div", _hoisted_135, [
      _createElementVNode("div", _hoisted_136, [
        _createElementVNode("button", {
          class: "btn-close-example",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleModal('example-fb-profile')))
        }, _hoisted_138),
        _hoisted_139,
        _hoisted_140
      ])
    ])
  ]))
}